import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('mainslider', '.slider');
loader('categoryslider', '.category-block');
loader('menu', '.menu--mobile');
loader('sliders/mainslider', '.slider');
loader('sliders/usps', '.usps-slider');
loader('faqAccordion', '.questions');
loader('sliders/product', '.spotlight-slider');
loader('blogslider', '.blogslider');
loader('blogsliderSingleProduct', '.blogslider-singleproduct');
loader('products', '.product-archive');
loader('brandslider', '.brand');
loader('filter', '.archive-filter--mobile');
loader('sortby', '.filter-bar__sort');
loader('archiveFilter', '.archive-filter--archive');
loader('sortbyArchive', '.filter-bar__archive');
loader('wishlist', '.header__favorites');
loader('atcpopup', '#yith-wacp-mini-cart');
loader('singleproduct', '.snep-product');
loader('search', '.search-results');
loader('accordionSingleProduct', '.singleproductaccordion');
loader('productBars', '.panel__bars');
loader('scroll', '.post__content a');
loader('singleProductDesktop', '.desktopcontent');
loader('stickyCartButton', '.snep-product__add-to-cart');
loader('openCoupon', '.woocommerce-form-coupon-header');
loader('dashboardIcons', '.dashboard-sneppies__card');
loader('dashboardListIcons', '.dashboard-sneppies__li');
loader('sizeChart', '.size-chart__toggler');
loader('insertSizeChart', '.archive-grid, .sb-product-attr__taxonomy');
